export default "/images/ff6bd5308d90feb46401e45eb732c961.avif";